module.exports = __webpack_public_path__ + "3f13b23c676620fe1b6eb36eeb2ff1e5.pdf";